/**
 * Created by arey on 5/4/17.
 */
const store = require('store');

// Keys
const LANGUAGE_KEY = 'language';

module.exports = {
  /**
   * Set Language Selected
   * @param language
   */
  setLanguage(language) {
    store.set(LANGUAGE_KEY, language);
  },
  /**
   * Get Language Selected
   */
  getLanguage() {
    return store.get(LANGUAGE_KEY);
  },
  /**
   * Remove Language Key
   */
  removeLanguage() {
    store.remove(LANGUAGE_KEY);
  },
  /**
   * Remove all the store
   */
  removeAll() {
    store.clearAll();
  },
};
